var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: _vm.dialogTitle,
            visible: _vm.visibleDialog,
            "before-close": _vm.closeDialog,
            width: _vm.form.leadState == 5 ? "900px" : "350px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibleDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "demo-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.form.leadState == 5 ? 8 : 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "tal",
                          attrs: {
                            label: "沟通方式",
                            prop: "communicationMode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择沟通方式",
                                size: "small",
                              },
                              on: { change: _vm.changeCommunicationMode },
                              model: {
                                value: _vm.form.communicationMode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "communicationMode", $$v)
                                },
                                expression: "form.communicationMode",
                              },
                            },
                            _vm._l(_vm.followupWayList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "tal",
                          attrs: { label: "名单状态", prop: "leadState" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择名单状态",
                                size: "small",
                              },
                              on: { change: _vm.getSource },
                              model: {
                                value: _vm.form.leadState,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "leadState", $$v)
                                },
                                expression: "form.leadState",
                              },
                            },
                            _vm._l(_vm.nameStatusList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.leadState == 4
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "tal",
                              attrs: { label: "关闭原因", prop: "closeReason" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择关闭原因",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.closeReason,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "closeReason", $$v)
                                    },
                                    expression: "form.closeReason",
                                  },
                                },
                                _vm._l(
                                  _vm.closeCauseList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item tal",
                          attrs: { label: "跟进情况", prop: "followResult" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              "show-word-limit": "",
                              type: "textarea",
                              maxlength: "1000",
                              resize: "none",
                              size: "small",
                              rows: 5,
                              placeholder: "请填写跟进的情况",
                            },
                            model: {
                              value: _vm.form.followResult,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "followResult",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.followResult",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.leadState == 5
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("h2", [_vm._v("联系人信息")]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "流量来源" } },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.form.clueSource,
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "overHide" }, [
                                    _vm._v(_vm._s(_vm.form.clueSource)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人姓名", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "20",
                                  placeholder: "请填写联系人姓名",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "name",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "selection-fill",
                              attrs: {
                                label: "联系人手机",
                                prop: "mobilePhone",
                              },
                            },
                            [
                              _vm.form.isEditMobilePhone === 0
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.form.mobilePhone)),
                                  ])
                                : _c("el-input", {
                                    attrs: {
                                      maxlength: "11",
                                      placeholder: "请填写联系人手机",
                                      size: "small",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.form.mobilePhone =
                                          _vm.form.mobilePhone.replace(
                                            /[^\d]/g,
                                            ""
                                          )
                                      },
                                    },
                                    model: {
                                      value: _vm.form.mobilePhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "mobilePhone",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.mobilePhone",
                                    },
                                  }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "selection-fill",
                              class: _vm.errorMsg ? "mb-50" : "",
                              attrs: { label: "联系人电话", prop: "telephone" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请填写联系人电话",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.form.telephone,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "telephone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.telephone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人角色", prop: "role" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择联系人角色",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.role,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "role", $$v)
                                    },
                                    expression: "form.role",
                                  },
                                },
                                _vm._l(_vm.roleList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.title,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人性别" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "small" },
                                  model: {
                                    value: _vm.form.gender,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "gender", $$v)
                                    },
                                    expression: "form.gender",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("未知"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("先生"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("女士"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人部门" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "20",
                                  placeholder: "请填写联系人部门",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.form.department,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "department",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.department",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人职位" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "20",
                                  placeholder: "请填写联系人职位",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.form.position,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "position",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.position",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.leadState == 5
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("h2", [_vm._v("公司信息")]),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "公司名称", prop: "companyName" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "50",
                                  placeholder: "请填写公司名称",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.form.companyName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "companyName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.companyName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "所在区域" } },
                            [
                              _c("el-cascader", {
                                attrs: {
                                  size: "small",
                                  filterable: "",
                                  props: { checkStrictly: true },
                                  options: _vm.areaData,
                                  clearable: "",
                                  placeholder: "请选择所在区域",
                                },
                                model: {
                                  value: _vm.form.companyRegion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "companyRegion", $$v)
                                  },
                                  expression: "form.companyRegion",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属行业",
                                prop: "industry",
                                rules: [
                                  {
                                    required: _vm.isCustomAuth,
                                    message: "请选择所属行业",
                                    trigger: "change",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择所属行业",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.industry,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "industry", $$v)
                                    },
                                    expression: "form.industry",
                                  },
                                },
                                _vm._l(
                                  _vm.industryList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "团队规模" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择团队规模",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.teamSize,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "teamSize", $$v)
                                    },
                                    expression: "form.teamSize",
                                  },
                                },
                                _vm._l(
                                  _vm.employeeCountList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.form.remarkDict,
                            function (item, key, index) {
                              return _c(
                                "el-form-item",
                                { key: index, staticClass: "item-max" },
                                [
                                  key.length > 6
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            slot: "label",
                                            effect: "dark",
                                            content: key,
                                            placement: "top",
                                          },
                                          slot: "label",
                                        },
                                        [_c("span", [_vm._v(_vm._s(key))])]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v(_vm._s(key))]
                                      ),
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请填写客户需求",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.form.remarkDict[key],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.remarkDict,
                                          key,
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.remarkDict[key]",
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _c("h2", [_vm._v("线索信息")]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "线索来源", prop: "source" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择线索来源",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.source,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "source", $$v)
                                    },
                                    expression: "form.source",
                                  },
                                },
                                _vm._l(
                                  _vm.customerSourceArr,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.title,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "归属人员" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择归属人员",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.form.crmOwnerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "crmOwnerId", $$v)
                                    },
                                    expression: "form.crmOwnerId",
                                  },
                                },
                                _vm._l(
                                  _vm.belongerList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.accountName,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v("取消")]
              ),
              _vm.form.leadState == 5
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.btnLoading,
                        type: "primary",
                        size: "small",
                      },
                      on: { click: _vm.addFollowRecord },
                    },
                    [_vm._v("保存并创建线索")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.btnLoading,
                        type: "primary",
                        size: "small",
                      },
                      on: { click: _vm.addFollowRecord },
                    },
                    [_vm._v("保存")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }